import { type JSX, PropsWithChildren, useEffect } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import * as amplitude from '@amplitude/analytics-browser';

import { useAthenaSessionQuery } from '../graphql/athena/queries/Session';

export const AmplitudeSession = ({ children }: PropsWithChildren): JSX.Element | null => {
  const { customerUuid, email } = useAthenaSessionQuery();

  useEffect(() => {
    if (customerUuid) {
      amplitude.setUserId(customerUuid);
    }
  }, [customerUuid]);

  useEffect(() => {
    if (email) {
      const identifyEvent = new amplitude.Identify();
      identifyEvent.set('email', email);
      amplitude.identify(identifyEvent);
    }
  }, [email]);

  return <div>{children}</div>;
};
